(function () {
  const selectors = {
    checkbox: ".juo-subscribe-cart__selling-plans-checkbox",
    select: ".juo-subscribe-cart__selling-plan-switcher--select",
  };

  function initializeSwitcher() {
    document.addEventListener("click", function (event) {
      if (
        event.target != null &&
        "matches" in event.target &&
        event.target.matches(selectors.checkbox)
      ) {
        const checkbox = event.target;
        var boxId = checkbox.getAttribute('data-box-id');
        var sellingId = checkbox.getAttribute('data-selling-id');
        var varId = checkbox.getAttribute('data-variant-id');

              addRemoveItem('auto', varId, boxId, sellingId, checkbox.closest(".juo-subscribe-switcher"));

        
        if (checkbox.checked) {
          // setSellingPlan(
          //   checkbox.dataset.variantId,
          //   sellingPlanSelect.value,
          //   checkbox.closest(".juo-subscribe-switcher")
          // );
          
        } else {
          
          // removeSellingPlan(
          //   checkbox.dataset.variantId,
          //   checkbox.closest(".juo-subscribe-switcher")
          // );
          
        }
      }
    });

    document.addEventListener("change", function (event) {
      if (
        event.target != null &&
        "matches" in event.target &&
        event.target.matches(selectors.select)
      ) {
        const select = event.target;
        var boxId = select.getAttribute('data-box-id');
        var sellingId = select.value;
        var varId = select.getAttribute('data-variant-id');

           addRemoveItem('sub', varId, boxId, sellingId, select.closest(".juo-subscribe-switcher"));
        
        // setSellingPlan(
        //   select.dataset.variantId,
        //   select.value,
        //   select.closest(".juo-subscribe-switcher")
        // );
      }
      
    });
  }

  const ADD_OPERATION = "ADD";
  const CHANGE_OPERATION = "CHANGE";
  const UPDATE_OPERATION = "UPDATE";
  const CART_TYPE = "CART";
  const CART_HTML_TYPE = "CART_HTML";
  
  function performCartOperation(cartData, operationType = ADD_OPERATION) {
    var url = "/cart/add.js";
    var method = operationType.includes(CART_TYPE) ? "GET" : "POST";
    
    if (operationType === CHANGE_OPERATION) {
      url = "/cart/change.js";
    } else if (operationType === UPDATE_OPERATION) {
      url = "/cart/update.js";
    } else if (operationType === CART_TYPE) {
      url = "/cart.js";
    } else if (operationType === CART_HTML_TYPE) {
    }

  
    var requestOptions = {
      method: method,
      credentials: "same-origin",
      headers: {
        "Content-Type": operationType.includes("HTML") ? "text/html" : "application/json",
        "X-Requested-With": "xmlhttprequest",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": 0
      },
      body: cartData && JSON.stringify(cartData)
    };
    
    return fetch(url, requestOptions)
      .then(response => response.text())
      .then(data => {
        var responseData = JSON.parse(data);
        if (responseData.status) {
            throw new Error(responseData.description);
        }
        return responseData;
      })
      .catch(error => {
        console.error(error);
      });
  }
  
  function addCartItems(cartItems) {
    return performCartOperation({ items: cartItems });
  }
  
  function updateCartItems(cartUpdates) {
    return performCartOperation({ updates: cartUpdates }, UPDATE_OPERATION);
  }
  
  function addRemoveItem(type, varId, boxId, sellingPlanId, wrapper) {
    if (sellingPlanId == null) {
      return;
    }
    document.querySelector("#CartDrawer").classList.add("loading_cart");
    wrapper?.classList.add("loading");
    wrapper?.querySelector(".pill-loader")?.setAttribute("aria-busy", "true");
    
    const rootPath = window.Shopify.routes.root ?? "/";
    fetch(rootPath + "cart.js")
      .then((response) => response.json())
      .then(function (cart) {
        var viewData = { 
          items : []
        };
        var selling_item = cart.items.filter(function(item) {
          return item.properties['_box'] == boxId && item.selling_plan_allocation;
        });
       
        
        var final_item = cart.items.filter(function(item) {
          return item.properties['_box'] == boxId;
        }).reverse();

        var free_scoop_item = cart.items.filter(function(item) {
          return item.line_price == 0 ;
        });
        
        if (final_item.length > 0) {
          if (selling_item.length > 0 && type != 'sub') {
              final_item.forEach((item) => {
                if (free_scoop_item.length > 0) {
                    if (item.id != free_scoop_item[0].id) {
                      var jsonData = {};
                       jsonData['quantity'] = item.quantity;
                       jsonData['id'] = item.id;
                       jsonData['properties'] = {
                         ...item.properties,
                          _juo_subscribe_cart: null,
                          _juo_source: "subscribe-cart",
                       }
                       viewData.items.push(jsonData);
                    }
                }else {
                   var jsonData = {};
                       jsonData['quantity'] = item.quantity;
                       jsonData['id'] = item.id;
                       jsonData['properties'] = {
                         ...item.properties,
                          _juo_subscribe_cart: null,
                          _juo_source: "subscribe-cart",
                       }
                       viewData.items.push(jsonData);
                }
              });
          } else {
            final_item.forEach((item) => {
              if (free_scoop_item.length > 0) {
                 if (item.id != free_scoop_item[0].id) {
                   var jsonData = {};
                     jsonData['quantity'] = item.quantity;
                     jsonData['id'] = item.id;
                     jsonData['selling_plan'] = sellingPlanId;
                     jsonData['properties'] = {
                       ...item.properties,
                        _juo_subscribe_cart: sellingPlanId,
                        _juo_source: "subscribe-cart",
                        _subscription_item: false,
                     }
                     viewData.items.push(jsonData);
                   } else {
                     var jsonData = {};
                     jsonData['quantity'] = item.quantity;
                     jsonData['id'] = item.id;
                
                     jsonData['properties'] = {
                       ...item.properties
                     }
                     viewData.items.push(jsonData);
                   }
              }else{
                var jsonData = {};
                     jsonData['quantity'] = item.quantity;
                     jsonData['id'] = item.id;
                     jsonData['selling_plan'] = sellingPlanId;
                     jsonData['properties'] = {
                       ...item.properties,
                        _juo_subscribe_cart: sellingPlanId,
                        _juo_source: "subscribe-cart",
                        _subscription_item: false,
                     }
                     viewData.items.push(jsonData);
              }
            });
          }
          var removeData = final_item.reduce(function (itemsToUpdate, item) {
            var itemId = item.key;
            itemsToUpdate[itemId] = 0;
            return itemsToUpdate;
          }, {});
        } else {
          var single_selling_item = cart.items.filter(function(item) {
            return item.id == varId && item.selling_plan_allocation;
          });
          var single_final_item = cart.items.filter(function(item) {
            return item.id == varId;
          });
          if (single_selling_item.length > 0 && type != 'sub') {
            single_final_item.forEach((item) => {
               var jsonData = {};
               jsonData['quantity'] = item.quantity;
               jsonData['id'] = item.id;
               jsonData['properties'] = {
                 ...item.properties,
                  _juo_subscribe_cart: null,
                  _juo_source: "subscribe-cart",
                  _subscription_item: false,
               }
               viewData.items.push(jsonData);
            });
          } else {
            single_final_item.forEach((item) => {
               var jsonData = {};
               jsonData['quantity'] = item.quantity;
               jsonData['id'] = item.id;
               jsonData['selling_plan'] = sellingPlanId;
               jsonData['properties'] = {
                 ...item.properties,
                  _juo_subscribe_cart: sellingPlanId,
                  _juo_source: "subscribe-cart",
                  _subscription_item: true,
               }
               viewData.items.push(jsonData);
            });
          }
          var removeData = single_final_item.reduce(function (itemsToUpdate, item) {
            var itemId = item.key;
            itemsToUpdate[itemId] = 0;
            return itemsToUpdate;
          }, {});
        }
        
        // return false;
        
        $.when(
          updateCartItems(removeData)
        ).done(function() {
          setTimeout(function() {
            $.when(
              addCartItems(viewData.items)
            ).done(function(data) {
              new theme.CartDrawer();
              reloadCart(data);
              document.querySelector("#CartDrawer").classList.remove("loading_cart");
              wrapper?.classList.remove("loading");
              wrapper?.querySelector(selectors.select)?.classList.remove("hidden");
              wrapper?.querySelector(".pill-loader")?.removeAttribute("aria-busy");
              console.log('updateCartItems');
              changeCart();
            });
          }, 1000);
        });
      });
  }

  function setSellingPlan(variantId, sellingPlanId, wrapper) {
    if (sellingPlanId == null) {
      return;
    }
    document.querySelector("#CartDrawer").classList.add("loading_cart");
    wrapper?.classList.add("loading");
    wrapper?.querySelector(".pill-loader")?.setAttribute("aria-busy", "true");

    const rootPath = window.Shopify.routes.root ?? "/";
    console.log("setSellingPlan fuction");
    fetch(rootPath + "cart.js")
      .then((response) => response.json())
      .then(function (cart) {
        cart.items.forEach((item) => {
          if (String(item.variant_id) === variantId) {
            const sectionsToBundle = [];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:prepare-bundled-sections", {
                bubbles: true,
                detail: { sections: sectionsToBundle },
              })
            );

            fetch(rootPath + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                selling_plan: sellingPlanId,
                properties: {
                  ...item.properties,
                  _juo_subscribe_cart: sellingPlanId,
                  _juo_source: "subscribe-cart",
                },
                sections: sectionsToBundle,
              }),
            })
              .then((response) => response.json())
              .then((cartContent) => {
                
                new theme.CartDrawer();
                reloadCart(cartContent);
                
              })
              .finally(() => {
                console.log("addSellingPlan final")
                document.querySelector("#CartDrawer").classList.remove("loading_cart");
                wrapper?.classList.remove("loading");
                wrapper?.querySelector(selectors.select)?.classList.remove("hidden");
                wrapper?.querySelector(".pill-loader")?.removeAttribute("aria-busy");
                 changeCart();
              });
          }
        });
      });
  }

  function removeSellingPlan(variantId, wrapper) {
    if (variantId == null) {
      return;
    }
    document.querySelector("#CartDrawer").classList.add("loading_cart");
    wrapper?.classList.add("loading");
    wrapper?.querySelector(".pill-loader")?.setAttribute("aria-busy", "true");

    const rootPath = window.Shopify.routes.root ?? "/";
    console.log("setSellingPlan remove fuction")
    fetch(rootPath + "cart.js")
      .then((response) => response.json())
      .then(function (cart) {
        cart.items.forEach((item) => {
          if (String(item.variant_id) === variantId) {
            const sectionsToBundle = [];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:prepare-bundled-sections", {
                bubbles: true,
                detail: { sections: sectionsToBundle },
              })
            );

            fetch(rootPath + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                selling_plan: null,
                properties: {
                  ...item.properties,
                  _juo_subscribe_cart: null,
                },
                sections: sectionsToBundle,
              }),
            })
              .then((response) => response.json())
              .then((cartContent) => {
                new theme.CartDrawer();
                reloadCart(cartContent);
                 
              })
              .finally(() => {
                console.log("removeSellingPlan final");
                document.querySelector("#CartDrawer").classList.remove("loading_cart");
                wrapper?.classList.remove("loading");
                wrapper?.querySelector(selectors.select)?.classList.add("hidden");
                wrapper?.querySelector(".pill-loader")?.removeAttribute("aria-busy");
                changeCart();
              });
          }
        });
      });
  }

  function reloadCart(cartContent) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent,
        },
      })
    );
  }

function changeCart(cart_count) {
  console.log("changeCartchangeCartchangeCart")
  fetch('/?section_id=cart-ajax')
    .then(response => response.text())
    .then(data => {
      const respHtml = new DOMParser().parseFromString(data, 'text/html');
      let respoData = respHtml.querySelector(`#CartPageForm`).innerHTML;
      $("#CartPageForm").html(respoData);
    })
    .catch(error => {
      console.error(error);
    });
}

  function main() {
    if (window.Shopify != null) {
      if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
      ) {
        initializeSwitcher();
      } else {
        document.addEventListener("DOMContentLoaded", initializeSwitcher);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();